import './checkbox.scss';

const Checkbox = (props) => {
    const {
        error,
        displayError,
        message,
        helpertext,
        label,
        options,
        ...inputProps 
    } = props;

    const inputName = props.name || "checkbox-group";

    return (
        <label 
          htmlFor={`${props.id || props.value}`} 
          className="input input-checkbox"
        >
            <span className="group">
                <input
                    id={`${props.id || props.value}`}
                    key={`${props.id || props.value}`}
                    type="checkbox"
                    {...inputProps}
                    name={inputName}          // ✔ FIX HERE
                    value={props.value}
                />

                <span className="svg-checkbox">
                    <svg className="svg" width="24" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                            <rect className="fill" height="20" rx="2" width="20" x="2" y="2"></rect>
                            <polyline className="stroke checkbox-checked" points="7 13 10 16 17 8"></polyline>
                        </g>
                    </svg>
                </span>
                
                <span className="label-inline">{props.label}</span>
            </span>
        </label>
    )
}

export default Checkbox;
